<script lang="ts">
    import { getBorderRadius } from '$lib/global/helper/border-radius';
    import { cn } from '$lib/utils/cn';

    import { cubicOut } from 'svelte/easing';

    import type { TransitionConfig } from 'svelte/transition';

    export let id: string | null = null;
    export let open = false;
    export let wrapperClass = '';
    export let contentClass = '';

    const dropdown = (node: HTMLElement, { duration }: { duration: number }): TransitionConfig => {
        return {
            duration,
            css: (played: number) => {
                const easedPlayed = cubicOut(played);
                const easedRemaining = 1 - easedPlayed;

                return `
                    transform: translateY(-${easedRemaining * 16}px);
                    opacity: ${easedPlayed * 100}%;
				`;
            },
        };
    };

    const dropdownWrapperClasses = cn(
        'fun-absolute fun-left-0 fun-right-0 fun-top-full fun-z-[1000] fun-flex fun-h-auto',
        wrapperClass,
    );

    const dropdownContentClasses = cn(
        'fun-relative fun-mb-4 fun-mt-2 fun-flex fun-max-h-[400px] fun-w-full fun-origin-top fun-transform fun-flex-col fun-overflow-hidden fun-border fun-bg-white fun-shadow-lg',
        getBorderRadius('dropdown'),
        contentClass,
    );
</script>

{#if open}
    <div {id} class={dropdownWrapperClasses}>
        <div
            class={dropdownContentClasses}
            in:dropdown={{ duration: 300 }}
            out:dropdown={{ duration: 150 }}
        >
            <slot />
        </div>
    </div>
{/if}
